import { removeCardGroupCustomerLink } from '../forms/cardGroups/form-cardgroup-helpers';
import useAuth from '../../hooks/auth-hooks';
import { ICustomerSearch } from '../../models/customer.interface';

/**
 * Displays a linked Customer for the  Card Group add/edit form
 * 
 * @param {HTMLElement} container container for the list items
 * @param {object} data list data
 */
export const displayLinkedCustCGWidget = ( container: HTMLElement, data: ICustomerSearch[] ) => {
  const { accessLevel, accessType } = useAuth()!;

  container.innerHTML = '';

  for (const e of data) {
    const div = document.createElement('div');
    div.className = `single-row-widget aafp_border-radius linked-element ele_access_${e.customerId}`;
    div.setAttribute(`data-customer`, e.customerId.toString());
    div.setAttribute('data-name', e.customerName!);
    div.setAttribute('data-partner', e.partnerName);
    div.setAttribute('data-linked', e.customerId.toString()); 

    const span = document.createElement('span');
    span.textContent = e.customerName!;

    const i = document.createElement('i');
    i.className = `far fa-trash-alt element-remove-${e.customerId}`;
    i.setAttribute('data-toggle', 'tooltip');
    i.setAttribute('data-placement', 'bottom');
    i.setAttribute('title', `Remove ${e.customerName}`);

    div.appendChild(span);
    if ( accessType != 'R' && accessLevel === 'A' ) {
      div.appendChild(i);
    }    
    container.appendChild(div);

    removeCardGroupCustomerLink(`.element-remove-${e.customerId}`, e.customerId);
  };

  data.length = 0; 
}